export default "__VITE_ASSET__BD5bunce__"